import logo from '@assets/images/dreamer.png';
import { JobReportCriteria } from '@features/buyer/jobs/single-job-detail/job-report/job-report-criteria';
import {
  type JobPdfDetails,
  styles,
} from '@features/buyer/jobs/single-job-detail/job-report/jobReportModel';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import i18n from '@translations/i18n';

// react-pdf renders outside React context, so use the i18n instance directly
const t = (key: string): string => String(i18n.t(key));

interface JobReportDocumentProps {
  pdfData: JobPdfDetails | undefined;
}

export function JobReportDocument({
  pdfData,
}: JobReportDocumentProps): JSX.Element {
  if (!pdfData) {
    return <Document />;
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.firstContainer}>
          <View style={styles.sectionsHeader}>
            <Image src={logo} style={styles.logoImage} />
            <Text style={styles.textBold}>{t('report.title')}</Text>
          </View>
          <View style={styles.sectionHeading}>
            <Text>{t('report.jobInformation')}</Text>
          </View>
          <View style={styles.sectionContainer}>
            <View style={styles.sectionTableJob}>
              <Text style={styles.sectionTableHead}>{t('report.jobNumber')}</Text>
              <Text style={styles.text}>{pdfData.id}</Text>
            </View>
            <View style={styles.sectionTableIn}>
              <Text style={styles.sectionTableHead}>{t('report.inspectionDate')}</Text>
              <Text style={styles.text}>{pdfData.ratingStartedAt}</Text>
            </View>
            <View style={styles.sectionTable}>
              <Text style={styles.sectionTableHead}>{t('report.preparedFor')}</Text>
              <Text style={styles.text}>{pdfData?.buyer}</Text>
            </View>
            <View style={styles.sectionTable}>
              <Text style={styles.sectionTableHead}>{t('report.r8tr')}</Text>
              <Text style={styles.text}>
                {pdfData?.r8tr ? pdfData?.r8tr : ''}
              </Text>
            </View>
          </View>
          <View style={styles.sectionHeading}>
            <Text>{t('report.vehicleInformation')}</Text>
          </View>
          <View style={styles.sectionContainer}>
            <View style={styles.sectionTableJob}>
              <Text style={styles.sectionTableHead}>{t('report.year')}</Text>
              <Text style={styles.text}>{pdfData.year}</Text>
            </View>
            <View style={styles.sectionTable}>
              <Text style={styles.sectionTableHead}>{t('report.make')}</Text>
              <Text style={styles.text}>{pdfData.make}</Text>
            </View>
            <View style={styles.sectionTable}>
              <Text style={styles.sectionTableHead}>{t('report.model')}</Text>
              <Text style={styles.text}>{pdfData.model}</Text>
            </View>
            <View style={styles.sectionTableIn}>
              <Text style={styles.sectionTableHead}>{t('report.vin')}</Text>
              <Text style={styles.text}>{pdfData.vinOrSerial}</Text>
            </View>
          </View>
          {pdfData?.overAllComments && (
            <View>
              <View style={styles.sectionHeading}>
                <Text>{t('report.jobResult')}</Text>
              </View>
              <View style={styles.sectionHeadingBanner}>
                <Text>{t('report.messageFromR8tr')}</Text>
              </View>
              <View style={styles.sectionOverallRating}>
                {/* <View style={styles.sectionOverallRatingBox}>
                                <Text>
                                    {pdfData?.overAllRating?.toFixed(1)}/8
                                </Text>
                            </View> */}
                <View style={styles.sectionMessage}>
                  <Text style={styles.ratingCriteriaOptionValue}>
                    {pdfData?.overAllComments
                      ? pdfData?.overAllComments
                      : ' no comments available'}
                  </Text>
                </View>
              </View>
            </View>
          )}
        </View>
      </Page>
      <JobReportCriteria pdfData={pdfData} />
    </Document>
  );
}
